import CONF from 'config/conf.singleton';
import H from 'constants/httpMethod.const';
import endpoint from 'utils/backend/endpoint.util';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import { fromAnyDateToZuluDayBgn, fromAnyDateToZuluDayEnd } from 'utils/converters/time/from.util';
import actionBe from 'utils/mw/actionBe.util';
import isMissing from 'utils/predicates/any/isMissing.util';

// DEPRECATED: should use one of the personal or the all staff endpoints instsead
const beGetCashup = actionBe('beGetCashup', ({ AT, ATAG, begin, end, desc, pageNumber }) => {
  const options = {
    base: CONF.transactionApiRoot,
    AT,
    name: ATAG,
    params: {
      // eslint-disable-next-line no-nested-ternary
      ord: desc ? '-created' : 'created',
      pag: fromAnyToTrimmed(pageNumber) || void 1,
      bgn: fromAnyDateToZuluDayBgn(begin),
      end: fromAnyDateToZuluDayEnd(end),
    },
  };

  // NOTE: back end doesn't handle extra parameters, and linkTo utility can't remove them automatically
  // NOTE: keep this long form, so it will be easy to search to projects for get path and see the 3 different results

  if (!isMissing(desc)) {
    return endpoint(H.get, 'cashup/:salonId/?start=:bgn&end=:end&ordering=:ord?', options);
  }

  if (!isMissing(pageNumber)) {
    return endpoint(H.get, 'cashup/:salonId/?start=:bgn&end=:end&page=:pag?', options);
  }

  return endpoint(H.get, 'cashup/:salonId/?start=:bgn&end=:end', options);
});

export default beGetCashup;
